module.exports = __webpack_public_path__ + "static/media/fullHeart.5a22473f.svg";